import React from "react";
import { FileText } from "lucide-react";
import { toast } from "react-toastify";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useReports, useRemoveReport } from "../hooks";
import { useMe } from "../../users/hooks/useMe";
import { UserRole } from "../../../__generated__/globalTypes";
import { formatDisplayDate } from "../../../helpers/date";

interface IProps {
  customerId?: number;
}

export const ReportsList: React.FC<IProps> = ({ customerId }) => {
  const { data, loading, refetch } = useReports({ where: { customerId } });
  const { data: meData } = useMe();
  const [remove] = useRemoveReport();

  const isAdmin = meData?.me?.role === UserRole.Admin;

  const handleRemove = async (id: number) => {
    if (!window.confirm("Supprimer ce rapport ? Cette action est irréversible.")) return;
    try {
      const { data } = await remove({ variables: { id } });
      if (data?.removeReport?.ok) {
        toast.success("Le rapport a été supprimé");
        refetch();
      } else {
        toast.error(data?.removeReport?.error ?? "Une erreur est survenue");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  if (loading) return <Loading />;

  if (!data?.reports?.results?.length) {
    return <EmptyList text="Aucun rapport" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Semaine du</TableCell>
          {!customerId && <TableCell header>Client</TableCell>}
          <TableCell header>Contenu</TableCell>
          {isAdmin && <TableCell header align="center">Actions</TableCell>}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.reports?.results?.map((report) => (
          <TableRow key={`report-${report.id}`} hover={false}>
            <TableCell>
              <span className="inline-flex items-center gap-1.5">
                <FileText className="w-4 h-4 text-gray-500" />
                {formatDisplayDate(report.weekStartDate)}
              </span>
            </TableCell>
            {!customerId && <TableCell>{report.customer?.name ?? "-"}</TableCell>}
            <TableCell className="max-w-xs truncate">{report.content}</TableCell>
            {isAdmin && (
              <TableCell align="center">
                <span
                  className="text-red-600 text-sm cursor-pointer hover:underline"
                  onClick={() => handleRemove(report.id)}
                >
                  Supprimer
                </span>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
